import { render, staticRenderFns } from "./LoginCardConfirmMail.vue?vue&type=template&id=6dda5449&scoped=true&"
import script from "./LoginCardConfirmMail.vue?vue&type=script&lang=ts&"
export * from "./LoginCardConfirmMail.vue?vue&type=script&lang=ts&"
import style0 from "./LoginCardConfirmMail.vue?vue&type=style&index=0&id=6dda5449&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dda5449",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
